export const LOGOUT_BROADCAST_KEY = "ali_logout_broadcast";

export function broadcastLogout(username) {
  if (!username) return;
  try {
    localStorage.setItem(LOGOUT_BROADCAST_KEY, JSON.stringify({ username, at: Date.now(), nonce: Math.random() }));
  } catch { /* Storage can be unavailable in private browsing; local logout still works. */ }
}

export function isLogoutForUser(event, username) {
  if (event?.key !== LOGOUT_BROADCAST_KEY || !event.newValue || !username) return false;
  try { return JSON.parse(event.newValue).username === username; }
  catch { return false; }
}

export function clearAuthStorageForUser(username) {
  if (!username) return;
  for (const storage of [localStorage, sessionStorage]) {
    try {
      const saved = JSON.parse(storage.getItem("ali_user") || "null");
      // Another tab may have signed into a different account after this event
      // was sent. Never erase its newer shared localStorage credentials.
      if (saved?.username !== username) continue;
      for (const key of ["ali_token", "ali_user", "ali_imp_backup"]) storage.removeItem(key);
      if (storage === sessionStorage) storage.removeItem("ali_session_only");
    } catch { /* An unreadable store is left alone rather than clearing another account. */ }
  }
}
